import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChevronLeft = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-hidden": "true",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		transform: "translate(8.2488 5.4696)",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Icon",
			d: "M7.28027 1.06055L1.81055 6.53027L7.28027 12L6.21973 13.0605L0.219727 7.06055C0.0790838 6.9199 2.52555e-07 6.72918 0 6.53027C3.15909e-08 6.33137 0.0790839 6.14065 0.219727 6L6.21973 0L7.28027 1.06055Z",
			fill: "currentColor"
		})
	})
});
export default SvgChevronLeft;
